module.exports = __webpack_public_path__ + "media/images/banner/klook/sp/rental-o_360_360_th-6488704572885627f8b77e9e52c17e28.jpg";